// extracted by mini-css-extract-plugin
export default {"table":"CompanyFinancialsTable_table__CNjMf"};